export const LOGIN_INVALID_REASON = "invalid"
export const LOGIN_EXPIRED_REASON = "expired"

export const loginInvalidMessage = "다른 장소에서 로그인을 시도하여 로그아웃 되었습니다."
export const loginExpiredMessage = "로그인 정보가 만료되었습니다. 다시 로그인해주세요."

export function isAuthFailure(error) {
    const status = error?.response?.status
    return status === 401 || status === 403
}

export function getLoginVerificationFailure(result, error) {
    if (result?.data?.isLogin === false) return LOGIN_INVALID_REASON
    if (isAuthFailure(error)) return LOGIN_EXPIRED_REASON
    return ""
}

export function getLoginVerificationMessage(reason) {
    if (reason === LOGIN_INVALID_REASON) return loginInvalidMessage
    if (reason === LOGIN_EXPIRED_REASON) return loginExpiredMessage
    return ""
}
